export const testimonials_data = [
  {
    key: '1',
    author: { name: 'Ivan Lucas', avatar: 'assets/img/testimonials/user-01.jpg' },
    role: 'HR Manager',
    content: "This system streamlined our HR processes, saving us time and boosting team efficiency.",
    dateAdded: '12/09/2024',
  },
  {
    key: '2',
    author: { name: 'John Mason', avatar: 'assets/img/testimonials/user-02.jpg' },
    role: 'HR Manager',
    content: 'This system has made payroll and attendance tracking so much easier for our team',
    dateAdded: '24/10/2024',
  },
  {
    key: '3',
    author: { name: 'Susan Hill', avatar: 'assets/img/testimonials/user-03.jpg' },
    role: 'HR Manager',
    content: "We've significantly reduced paperwork and manual errors since implementing this platform",
    dateAdded: '18/02/2024',
  },
  {
    key: '4',
    author: { name: 'Gary Payton', avatar: 'assets/img/testimonials/user-04.jpg' },
    role: 'HR Manager',
    content: 'Managing employee leave requests and benefits is now a hassle-free process',
    dateAdded: '17/10/2024',
  },
  {
    key: '5',
    author: { name: 'Jennifer Vaughn', avatar: 'assets/img/testimonials/user-05.jpg' },
    role: 'HR Manager',
    content: 'This platform has drastically cut down the time we spend on recruitment and onboarding.',
    dateAdded: '20/07/2024',
  },
  {
    key: '6',
    id: 'T346280',
    author: { name: 'Ricky Easley', avatar: 'assets/img/testimonials/user-06.jpg' },
    role: 'HR Manager',
    content: "The system's ease of use has greatly improved our HR team's productivity.",
    dateAdded: '10/04/2024',
  },
  {
    key: '7',
    author: { name: 'David Rodriguez', avatar: 'assets/img/testimonials/user-07.jpg' },
    role: 'HR Manager',
    content: "The platform allows me to update my personal details and view my payslips instantly",
    dateAdded: '29/08/2024',
  },
  {
    key: '8',
    author: { name: 'Dennis Lorenzo', avatar: 'assets/img/testimonials/user-08.jpg' },
    role: 'Employee',
    content: 'Submitting my timesheets and checking my attendance is super easy with this tool.',
    dateAdded: '22/02/2024',
  },
  {
    key: '9',
    author: { name: 'Barry Ducote', avatar: 'assets/img/testimonials/user-09.jpg' },
    role: 'Manager',
    content: 'Enhanced employee performance tracking and simplified payroll management effortlessly.',
    dateAdded: '03/11/2024',
  },
  {
    key: '10',
    author: { name: 'Judy Walton', avatar: 'assets/img/testimonials/user-10.jpg' },
    role: 'Employee',
    content: 'It’s great to see all my benefits and compensation details in one user-friendly interface.',
    dateAdded: '17/12/2024',
  },
];
